
import React from 'react';
import { Button } from '@/components/ui/button';
import { Volume } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface VoiceOutputProps {
  text: string;
  isDisabled?: boolean;
}

const VoiceOutput: React.FC<VoiceOutputProps> = ({ text, isDisabled = false }) => {
  const { toast } = useToast();

  const handleClick = () => {
    toast({
      description: "La función de audio está temporalmente deshabilitada",
      variant: "destructive"
    });
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={handleClick}
      disabled={true}
      aria-label="Escuchar respuesta (deshabilitado)"
      title="Escuchar respuesta (deshabilitado)"
      className="rounded-full h-8 w-8 p-1.5 opacity-50 cursor-not-allowed"
    >
      <Volume className="h-4 w-4" />
    </Button>
  );
};

export default VoiceOutput;
